import lottie from 'lottie-web/build/player/lottie_light';

start();

// Avoiding promises to save some bytes

function start() {
    let container = document.getElementById('siteHeader-animation');
    if (container) {
        startAnimation(container);
    } else {
        setTimeout(() => start(), 50);
    }
}

function startAnimation(container) {
    lottie.loadAnimation({
        container,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: window.RES.templateUri + '/assets/greenwave.json',
    });
}
